import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import "../../assets/styles/change-info.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";
import { apiConfirmUpdate, apiUpdateAccount, apiCheckDataAccount, apiFormUpdateAccount } from "../../services/api.service.js";
// import iconArrow from "../../icons/";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  Modal,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendMailHover from "../../icons/icon-send-mail-hover.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconSendPhoneHover from "../../icons/icon-send-phone-hover.png";
import iconImage from "../../icons/icon-send-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";
import iconImageHover from "../../icons/icon-send-image-hover.png";
import iconAddVideo from "../../icons/icon-add-video.png";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data: initialData, webSetting, typeModal, sendType } = location.state || {};
  const [data, setData] = useState(initialData);
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [idUserUpdate, setIdUserUpdate] = useState("");
  const [historyCode, setHistoryCode] = useState("");
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if(validateForm()) {
      setOpen(true);
    }
  }
  const handleClose = () => setOpen(false);

  // const updateUser = (type) => {
  //   console.log("Update:", type);
  //   handleClose(); // đóng popup sau khi chọn
  // };
  const handleCancel = async () => {
    navigate("/profile", { state: {...location.state, data}, replace: !!location.state?.lastBank });
  };
  const handleConfirm = async () => {
    if (!validateForm()) {
      return;
    }
    user.send_type = sendType;
    let body = {
      ...user,
      data_check: {
        ...dataCheck,
      },
      data_update: {
        update_type: user.update_type,
        content: contentUpdate,
      }
    };
    let checkDataOld = await apiCheckDataAccount(body);
    if (checkDataOld) {
      if (checkDataOld?.result || (timesCheckData >= 100 && checkDataOld?.allowSubmit >0)) {
          navigate("/handle-confirm", { state: {...location.state, data, submitData: body, resCheckDataOld: checkDataOld}, replace: !!location.state?.lastBank });
      } else {
        setLoading(false)
        Swal.fire({
          icon: (checkDataOld.countMatch/checkDataOld.count <0.5) ? "error" : "warning",
          title: "Chú ý",
          text: (checkDataOld.allowSubmit == 0 && sendType != 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch/checkDataOld.count*100) + "%",
          showCancelButton: true,
          cancelButtonText: 'Quay về chỉnh sửa',
          confirmButtonText: 'Tiếp tục gửi',
          // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
          showConfirmButton: (sendType === 'files' || checkDataOld.allowSubmit > 0),
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/handle-confirm", { 
              state: {
                ...location.state,
                data,
                submitData: body,
                resCheckDataOld: checkDataOld,
              },
              replace: !!location.state?.lastBank,
            });
            // update user
            // confirmUpdateUser(body, send_type);
          } else if (result.isDismissed) {
            setTimesCheckData(timesCheckData + 1)
          }
        });
      }
    }
  };
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: data.bank_name,
    bank_number: "",
    email: "",
    phone_number: "",
  });
  
  
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const removeVietnameseTones = (str) => {
    return str
      .normalize("NFD") // tách dấu ra khỏi ký tự
      .replace(/[\u0300-\u036f]/g, "") // xóa dấu
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D");
  };
  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase();
      value = value.slice(0, 4);
    }
    if(name === "phone_number") {
      value = value.replace(/^(\+?84)/, "0");
      value = value.slice(0, 4);
    }
    if (name === "name") {
      value = removeVietnameseTones(value).toUpperCase();
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };
  
  const inputDataUpdate = (event) => {
    let { name, value } = event.target;
    if (name === "name") {
      value = removeVietnameseTones(value).toUpperCase();
    }
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name == "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
        break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
        break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
        break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, []);

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!dataCheck.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    // if (data.phone_number) {
    //   if (!dataCheck.phone_number) {
    //     formIsValid = false;
    //     errors.phone_number = 'Vui lòng nhập 4 số cuối Số Điện Thoại';
    //   } else if (!/^\d{4}$/.test(dataCheck.phone_number)) {
    //     formIsValid = false;
    //     errors.phone_number = 'Số Điện Thoại không hợp lệ';
    //   }
    // }

    // Kiểm tra trường email
    // if (data.email) {
    //   if (!dataCheck.email) {
    //     formIsValid = false;
    //     errors.email = 'Vui lòng nhập 4 ký tự đầu Email';
    //   } else if (!/^[a-zA-Z0-9]{4}$/.test(dataCheck.email)) {
    //     formIsValid = false;
    //     errors.email = 'Email không hợp lệ';
    //   }
    // }

    // Kiểm tra trường bank_name
    if (!dataCheck.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng nhập Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!dataCheck.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "confirm_account":
        contentUpdate = "Xác minh tài khoản";
        break;
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else if (dataUpdate.name == dataCheck.name) {
        formIsValid = false;
        errors.nameUpdate = 'Họ tên cũ và họ tên mới phải khác nhau';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        // if (!dataUpdate.bank_type_change) {
        //   formIsValid = false;
        //   errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        // }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng nhập Ngân Hàng mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else {
          contentUpdate = ("Đổi số tài khoản - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name )
        }
        break;
        case "birthday": // Kiểm tra trường birth day
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
          } else {
            contentUpdate = dataUpdate.birth_day;
          }
          break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = () => {
    let type = sendType;
    if (validateForm()){
      if (type === 'files') {
          user.send_type = 'files';
          updateUserField('send_type', 'files')
          updateUser('files')
      } else {
        Swal.fire({
          icon: "warning",
          title: (type === "mail") ? `Bạn có thể sử dụng email ${data.email} để gửi mail xác thực thông tin?` : `Bạn có thể sử dụng số điện thoại ${data.phone_number} để gửi tin nhắn xác thực thông tin?`,
          text: (type === "mail") ? `Gửi SMS` : `Gửi email`,
          html: `
            <div className="confirm-update-wrapper">
            ${data.phone_number && type === "mail"
              ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua SMS</button>' 
              : data.email && type === "phone_number" ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua email</button>' : ''}
              <button id="confirm_send_type" class="button-confirm-update">Đúng, tiếp tục</button>
              </div>
              `,
          showCancelButton: false,
          showConfirmButton: false,
          didRender: () => {
            document.getElementById('change_send_type')?.addEventListener('click', () => {
              Swal.close();
              modalConfirmUpdate(type === "mail" ? "phone_number" : "mail");
            });
            document.getElementById('confirm_send_type').addEventListener('click', () => {
              Swal.close();
              updateUser(type)
            });
          }
        })
      }
    }
  }
  
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    if (updateInfo) {
      setData((previous) => ({
        ...previous,
        recent_requests: [{
          _id: updateInfo.id,
          update_type: body.update_type,
          id_verify: body.id_verify ? `xxxxxx${body.id_verify.slice(-2)}` : "",
          status: "no_process",
        }, ...(previous?.recent_requests || [])].slice(0, 2),
      }));
      setIdUserUpdate(updateInfo.id)
      setHistoryCode(body.id_verify || "");
      openModalConfirm(type);
    }
  };
  const updateUser = async (submit) => {
    if (validateForm()) {
      if (sendType === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (sendType === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (sendType === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...dataCheck,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        body.id_verify = checkDataOld.idVerify;
        if (sendType === "files" && !submit) {
          let descriptionFileUpload = "Bạn vui lòng tải lên 1 video có " + webSetting?.des_up_files?.length+ " thông tin dưới để xác minh tài khoản<br/><br/>";
          if (webSetting?.des_up_files?.length > 0) {
            webSetting.des_up_files.forEach(element => {
              descriptionFileUpload +=  (element) ? "" + element + "</br>" : ""
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
          confirmUpdateUser(body, sendType);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch/checkDataOld.count <0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit == 0 && sendType != 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch/checkDataOld.count*100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (sendType === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, sendType);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: {...location.state, data}, replace: !!location.state?.lastBank });
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 99 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 100MB.`,
        });
        return false;
      }
      return true;
    });
    
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    if (!validFiles[0].type.startsWith("video")) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu file tải lên là video",
      });
      return;
    }
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    if (previews.length + newPreviews.length > 1) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 1 file",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
    {(loading) && (
      <Loading loading={loading}/>
    )}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
      >
        <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting, lastBank: location.state?.lastBank} } currentPage={typeModal}/>

        <div className="content">
          {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
              {/* <div className="info-current">
                <Collapsible open={false} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                  <InfoUser />
                </Collapsible>
              </div> */}
              {/* <div className="confirm-info-old" style={{ textAlign: "left" }}> */}
                <span className="titlte-change-info">Thông tin đã liên kết tại hệ thống</span>
                <div className="from-input-change-info">
                  <span className="label-input-change-info" style={{ textAlign: "left" }}>Họ và tên:</span>
                  <input value={dataCheck.name} type="text" name="name" onChange={inputDataCheck} placeholder="Nhập họ và tên" />
                  {errors.name && <p className="error">{errors.name}</p>}
                  <span className="label-input-change-info" style={{ textAlign: "left" }}>Ngân hàng/Ví USDT:</span>
                  <select name="bank_name" value={dataCheck.bank_name} onChange={inputDataCheck}>
                    <option value={dataCheck.bank_name}>{dataCheck.bank_name}</option>
                    {config.LIST_BANK_NAME.map((bank, index) => (
                      <option key={index} value={bank}>
                        {bank}
                      </option>
                    ))}
                  </select>
                  {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                  <span className="label-input-change-info" style={{ textAlign: "left" }}>Số tài khoản/Ví USDT:</span>
                  <input value={dataCheck.bank_number} type="text" name="bank_number" onChange={inputDataCheck} placeholder="Số tài khoản" />
                  {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                </div>
              {/* </div> */}
              {typeModal !== "confirm_account" && <div className="from-input-change-info">
                {
                  {
                    "full_name": 
                    <>
                      <span className="titlte-change-info">THAY ĐỔI HỌ TÊN MỚI</span>
                      <span className="label-input-change-info" style={{ textAlign: "left" }}>Họ Tên Mới:</span>
                      <input value={dataUpdate.name} type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                      {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                    </>,
                    "phone_number": 
                    <>
                      <span className="titlte-change-info">THAY ĐỔI SỐ ĐIỆN THOẠI MỚI</span>
                      <span className="label-input-change-info" style={{ textAlign: "left" }}>Số Điện Thoại:</span>
                      <input type="text" name="phone_number" onChange={inputDataUpdate} placeholder="Số Điện Thoại Mới" />
                      {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                    </>,
                    "bank": 
                    <>
                      <span className="titlte-change-info" style={{ textAlign: "center" }}>{desChangeBank.title_change_bank}</span>
                      {/* <span className="label-input-change-info" style={{ textAlign: "left" }}>chọn yêu cầu:</span> */}
                      {/* <select type="input" name="bank_type_change" onChange={inputDataUpdate}>
                        <option value="">Chọn yêu cầu thay đổi</option>
                        {config.LIST_REQUEST_BANK.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </select> */}
                      {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                      <span className="label-input-change-info" style={{ textAlign: "left" }}>Ngân hàng/Ví USDT:</span>
                      <select name="bank_name" onChange={inputDataUpdate}>
                        <option value="">{desChangeBank.bank_name}</option>
                        {config.LIST_BANK_NAME.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </select>
                      {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                      <span className="label-input-change-info" style={{ textAlign: "left" }}>Số tài khoản/Ví USDT:</span>
                      <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder={desChangeBank.bank_number} />
                      {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                    </>,
                  }[typeModal]
                }
              </div>}
              <div className="mode-verify" style={{ textAlign: "left" }}>
                {/* <span className="modal-titlte" style={{ textAlign: "left" }}>VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span> */}
                <div className="btn-change-info">
                  <button onClick={() => handleCancel()} className="btn-cancel">
                    HỦY BỎ
                  </button>
                  <button onClick={() => handleConfirm()} className="btn-confirm">
                    XÁC NHẬN
                  </button>
                </div>
                {/* {(typeModal !== "birthday") &&
                <>
                  <div className="action action-verify">
                    
                    <button onClick={() => updateUser("mail")} className="action-verify-btn">
                      <img className="img-default" src={iconSendMail} alt="icon-bank" />
                      <img className="img-hover" src={iconSendMailHover} alt="icon-bank" />
                      &nbsp; GỬI QUA EMAIL
                    </button>
                    
                    <button onClick={() => updateUser("phone_number")} className="action-verify-btn">
                      <img className="img-default" src={iconSendPhone} alt="icon-bank" />
                      <img className="img-hover" src={iconSendPhoneHover} alt="icon-bank" />
                      &nbsp; GỬI QUA SĐT
                    </button>
                  </div>
                </>
                }
                <div className="action action-verify">
                  <button id="confirm_files_btn" onClick={() => updateUser("files")}>
                    <img className="img-default" src={iconImage} alt="icon-bank" />
                    <img className="img-hover" src={iconImageHover} alt="icon-bank" />
                      SĐT/EMAIL KHÔNG CÒN DÙNG THÔNG TIN ĐĂNG KÝ
                  </button>
                </div> */}
                <Modal open={open} onClose={handleClose}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      padding: 3,
                      borderRadius: "12px",
                      boxShadow: 24,
                      minWidth: 300,
                      textAlign: "center"
                    }}
                  >
                    <h3 style={{ marginTop: "0px"}} >Vui lòng chọn hình thức xác minh</h3>
                    <div className="action2 action-verify2" style={{ display: "flex", flexDirection: "column", paddingTop:"15px", paddingBottom:"10px" }}>
                      {/* <button onClick={() => updateUser("mail")} className="action-verify-btn2">
                        <img className="img-default2" src={iconSendMail} alt="icon-bank" />
                        &nbsp;{data.email ? "GỬI BẰNG EMAIL " + data.email : "CHƯA LIÊN KẾT"}
                      </button> */}

                      <button 
                        onClick={() => updateUser("phone_number")}
                        className="action-verify-btn2"
                        disabled={!data.phone_number}
                        >
                        <img className="img-default2" src={iconSendPhone} alt="icon-bank" />
                        {/* <img className="img-hover2" src={iconSendPhoneHover} alt="icon-bank" /> */}
                        {data.phone_number ? "GỬI BẰNG SĐT " + data.phone_number : "CHƯA LIÊN KẾT"}
                      </button>

                      <button onClick={() => updateUser("files")} className="action-verify-btn2">
                        <img className="img-default2" src={iconImage} alt="icon-bank" />
                        {/* <img className="img-hover2" src={iconImageHover} alt="icon-bank" /> */}
                        &nbsp; SĐT ĐĂNG KÝ KHÔNG CÒN DÙNG
                      </button>
                    </div>
                  </Box>
                </Modal>
              </div>
            </motion.div>
          {/* </Popup> */}
          <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
            <motion.div
              initial={{ opacity: 0, y: 75 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              id="modal-confirm"
              className="modal-confirm"
            >
              <div className="modal-close">
                <a className="icon-close" onClick={closeModalConfirm}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
                {historyCode && <p>Mã yêu cầu: <strong>{historyCode}</strong>. Vui lòng lưu mã để tra cứu lịch sử.</p>}
                {user.send_type === 'files' ? (
                  <div className="modal-confirm-content">
                    <img style={{ marginBottom: "25px" }} src={iconSuccess} alt="icon-success" />
                    <span>Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.</span>
                    <div className="btn-wrapper-home">
                      <div className="btn-send btn-home">
                          <a href={ webSetting.link_home }
                              target="_blank"
                              rel="noopener noreferrer">VỀ TRANG CHỦ
                          </a>
                      </div>
                    </div>
                    <div className="notification">
                      <p style={{ color: "#FC8B00", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                      <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                      <p>- Liên hệ <a href={ webSetting.link_cskh }
                        target="_blank"
                        rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                  </div>
                ): (
              <div className="modal-confirm-content">
                <img className="icon-warning" src={iconWarning} />
                {isSendMail ? (
                  <p>
                    Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{data.email}</span>, gửi tin nhắn tới email F168{" "}
                    <span style={{ color: "red" }}>{ webSetting.email }</span>, với nội dung:
                  </p>
                ) : user.send_type === 'phone_number' ? (
                  <p>
                    Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{data.phone_number}</span>, gửi tin nhắn tới số điện thoại F168{" "}
                    <span style={{ color: "red" }}>{ webSetting.phone_number }</span>
                  </p>
                ) : (
                  <p>
                    Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.
                  </p>
                )}
                <DataConfirm user={user}
                  dataCheck = {dataCheck}
                  dataUpdate = {dataUpdate}
                  webSetting = {webSetting}
                  idUserUpdate = {idUserUpdate}/>
                <div className="btn-send complete">
                <a
                  onClick={() => { setOpenResult(true); setCheckConfirm(true)}}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Đã hoàn thành
                </a>
                
              </div>
                <div className="notification">
                  <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                  <p>- Sau khi nhận được { (isSendMail) ? 'email' : 'tin nhắn' }, hệ thống xét duyệt từ 2-5 phút.</p>
                  <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                  <p>- Liên hệ <a href={ webSetting.link_cskh }
                    target="_blank"
                    rel="noopener noreferrer">CSKH 24/7</a> nếu cần hỗ trợ thêm.</p>
              </div>
              </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenResult(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
              {checkConfirm ? (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                  <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                </div>
                ) : (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                  <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenUploadFile(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success"/>
                  <span>VUI LÒNG CUNG CẤP VIDEO APP NGÂN HÀNG.</span>
                  <div style={{ marginTop: "-15px", marginBottom: "-10px", textAlign: "left" }}>
                    <Typography
                      sx={{ fontWeight: "bold", color: "black", mb: 1, textAlign: "left" }}
                    >
                      Yêu cầu:
                    </Typography>

                    <ul style={{ marginTop: 0, paddingLeft: "20px", color: "red" }}>
                      <li>
                        <span style={{ color: "red", marginLeft: "-5px" }}>
                          Video app ngân hàng có tên chủ tài khoản và số tài khoản
                        </span>
                        <span style={{ color: "black" }}>đã được liên kết.</span>
                      </li>

                      <li>
                        <span style={{ color: "red", marginLeft: "-5px" }}>
                          Bước cuối video vui lòng vào phần tin nhắn soạn tin theo cú pháp sau:
                        </span>
                        <span style={{ color: "black" }}>
                          Tôi tên (ví dụ: NGUYỄN VĂN A) là chủ tài khoản (ví dụ: acb123) tôi xác
                          nhận thay đổi các thông tin trên.
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      color: "black",
                      marginBottom: "-10px",
                      marginTop: "-15px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                  </Typography> */}
                  <Box
                    display="flex"
                    alignItems="center"
                    marginY={1}
                    flexWrap="wrap"
                    gap="8px 8px"
                  >
                    {previews.map((preview, index) => (
                      
                      <Box
                        onClick={() => handleRemoveImage(index)}
                        key={index}
                        sx={{
                          maxHeight: 80,
                          maxWidth: 90,
                          width: "auto",
                          height: "auto",
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        {console.log("preview", preview)}
                      {preview.type === "image" ? (
                        <img
                          src={preview.url}
                          alt={`preview-${index}`}
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <video
                          src={preview.url}
                          controls
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                      )}
                        <IconButton
                          className="delete-button"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                            p: 0,
                          }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                    
                    <Box>
                      <input
                        accept="video/*"
                        style={{ display: "none" }}
                        id="upload-button"
                        type="file"
                        onChange={handleMediaUpload}
                        multiple
                      />
                      {previews.length == 0 && <label htmlFor="upload-button">
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            <img
                              src={iconAddVideo}
                              alt="add video"
                              style={{ width: 60, height: 60, marginTop:"30px" }}
                            />
                            // <AddPhotoAlternateOutlined
                            //   sx={{ fontSize: "large" }}
                            // />
                          }
                          
                          onClick={() => {
                            if (previews.length >= 1) {
                              Swal.fire({
                                icon: "error",
                                title: "Chỉ được đính kèm 1 video!",
                                text: `Bạn cần xóa video cũ trước khi thêm video mới.`,
                              });
                            }
                          }}
                          sx={{
                            width: "200px",
                            height: "100px",
                            color: "#FC8B00",
                            border: "none",
                            borderRadius:3,
                            background: "#FFF2E2",
                            // borderColor: "#FC8B00",
                            // borderStyle: "solid",
                            "&:hover": {
                              borderColor: "#FC8B00",
                              color: "#FC8B00",
                              background: "#ffe7caff",
                            },
                          }}
                        >
                          Thêm
                        </Button>
                      </label>
                        }
                    </Box>
                  </Box>
                  <Typography variant="caption" sx={{ color: "#000000", fontSize:"14px" }}>
                    Cung cấp video đúng theo mô tả để được xét duyệt <br /> (video không được vượt quá 100MB)
                  </Typography>
                  {selectedImage.length >= 1 && (
                    <div>
                      <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type, true)}}>
                        Hoàn thành xác minh
                      </button>
                    </div>
                  )}
                </div>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
